(() => {
  document.querySelectorAll('[data-sn-sticky-buy]:not([data-ready])').forEach(bar => {
    bar.dataset.ready = 'true';
    const root = bar.closest('product-info');
    const sync = () => {
      const button = root.querySelector('product-form [data-add-to-cart]');
      const action = bar.querySelector('[data-sn-sticky-action]');
      const price = root.querySelector('.product__price [data-product-price]') || root.querySelector('.product__price');
      if (!button) { bar.hidden = true; return; }
      action.disabled = button.disabled;
      action.textContent = button.querySelector('[data-add-to-cart-text]')?.textContent.trim() || button.textContent.trim();
      bar.querySelector('[data-sn-sticky-price]').textContent = price?.textContent.trim() || '';
      bar.hidden = button.getBoundingClientRect().bottom >= 0;
      if (!bar.hidden) document.documentElement.style.setProperty('--sn-sticky-height', bar.offsetHeight + 'px');
    };
    bar.querySelector('[data-sn-sticky-action]').addEventListener('click', () => {
      const button = root.querySelector('product-form [data-add-to-cart]');
      if (button && !button.disabled) button.form.requestSubmit(button);
    });
    let frame;
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    new MutationObserver(schedule).observe(root.querySelector('.product__info'), {childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    sync();
  });
})();
